jQuery.feature_import("js-systemclassifications",
  () => import("./SystemClassifications.jsx"),
  mod => mod.feature_js_systemclassifications
);